import React from 'react';
import { MdArrowOutward } from "react-icons/md";
import image from '../../Assets/ima.PNG';

const HomeAbout = () => {
    return (
        <div className="pt-20">
            <div className="lg:flex md:flex grid lg:py-20 md:py-20 lg:px-40 md:px-30 px-4 p-10 w-full">
                <div className="lg:w-[60%] md:[60%]">
                    <h1 className="text-[#124E66] font-semibold">ABOUT</h1>
                    <h1 className="lg:text-4xl md:text-2xl text-xl font-bold lg:leading-[3.5rem] md:leading-[3rem] leading-[2rem]">
                        Fusing Experience, Crafting Excellence: Your Digital Ventures Partner
                    </h1>
                </div>
                <div className="pt-6 lg:pt-0 md:pt-0 lg:w-[40%] md:w-[40%] grid gap-3">
                    <p className="text-gray-600">
                        <span className="font-semibold">KayDee</span> is your dedicated partner for digital ventures.
                        Our experience and passion for excellence drive every project. Collaborating with you.
                    </p>
                    <p className="text-gray-600">
                        We leverage expertise to craft innovative solutions. With idvsol, navigate the dynamic digital
                        landscape confidently, as we shape the future through innovation, one venture at a time.
                    </p>
                    <div className="cursor-pointer flex gap-10 right-0 justify-self-end hover:bg-gray-300 rounded-full p-1 px-2 w-42">
                        <button>Learn More</button>
                        <div className="bg-gray-300 rounded-full p-1">
                            <MdArrowOutward />
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="relative rounded-lg w-[80%] h-[40vh] md:h-[50vh] lg:h-[50vh] bg-cover bg-center bg-fixed"
                style={{
                    backgroundImage: `url(${image})`,
                    justifySelf: 'center',
                }}
            ></div>
        </div>
    );
};

export default HomeAbout;
